/**
 * Interfaz base que deben implementar todos los agentes
 */
class AgentInterface {
  constructor(config = {}) {
    if (new.target === AgentInterface) {
      throw new Error('No se puede instanciar la clase abstracta AgentInterface');
    }
    this.config = config;
  }

  /**
   * Envía un mensaje al agente y devuelve la respuesta
   * @param {string} message - El mensaje del usuario
   * @param {Object} context - Contexto adicional (ej: historial de mensajes)
   * @returns {Promise<Object>} Respuesta del agente
   */
  async sendMessage(message, context = {}) {
    throw new Error('Método sendMessage() debe ser implementado');
  }

  /**
   * Obtiene la configuración del agente
   * @returns {Object} Configuración del agente
   */
  getConfig() {
    return this.config;
  }
}

export default AgentInterface;
